// src/components/Footer.jsx

import React from "react";
import "./Footer.css";

const Footer = () => {
    const email = "srivelmrm@gmail.com";
    const phone = "04257 247666";

  const handleCopyClick = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      alert(`${label} copied to clipboard!`);
    });
  };

  return (
    <footer
      className="footer"
    >
      <div className="footer-content">
        <div className="footer-section about">
          <h2>ABOUT SHRIVEL</h2>
          <p>
            <strong>Shrivel Hi-Tech Rice Industries</strong> - Premium rice millers and trusted suppliers from Kangayam, Tamil Nadu – delivering authentic Indian rice with a production capacity of 40 tons per day. Rooted in Tamil soil, milled with precision, and served with pride. From paddy fields to your plate, we bring home the taste of tradition.
          </p>
        </div>
        <div className="footer-section contact">
          <h2>CONTACT US</h2>
          <h4>SHRIVEL HITECH RICE INDUSTRIES</h4>
          <p>
            331/2, Kovai Road, Kadaiyur (Post), Kangayam – 638701, Tirupur District, Tamilnadu, India
            <br />
            Email: {" "}
            <button
  type="button"
  onClick={() => handleCopyClick(email, "Email")}
  style={{
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    color: "white",
    textDecoration: "none",
    cursor: "pointer",
    font: "inherit" // keeps same font style as surrounding text
  }}
>
  {email}
</button>

            <br />
            Customer Care No: {" "}
            <button
  type="button"
  onClick={() => handleCopyClick(phone, "Customer Care Number")}
  style={{
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    color: "white",
    textDecoration: "none",
    cursor: "pointer",
    font: "inherit" // keeps same font style
  }}
>
  {phone}
</button>

            </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
